import { AxiosError } from 'axios';
import Swal from 'sweetalert2';

const API_ERROR_MAP: Record<string, string> = {
  'Unique constraint failed on the fields: (`idCard`)': 'เลขบัตรประชาชนนี้มีอยู่ในระบบแล้ว',
  'Unique constraint failed on the fields: (`phoneNumber`)': 'เบอร์โทรนี้มีอยู่ในระบบแล้ว',
  'The provided value for the column is too long for the column': 'ข้อมูลที่กรอกยาวเกินกำหนด กรุณาตรวจสอบเบอร์โทร (ไม่เกิน 10 หลัก) หรือเลขบัตรประชาชน (ไม่เกิน 13 หลัก)',
};

const translateError = (raw: string): string => {
  for (const [key, thai] of Object.entries(API_ERROR_MAP)) {
    if (raw?.includes(key)) return thai;
  }
  return raw;
};

export const showErrorDialog = (error: any, title = 'เกิดข้อผิดพลาด') => {
  let message = '';

  if (error instanceof AxiosError) {
    const raw =
      error.response?.data?.message ??
      error.response?.data?.title ??
      error?.message;
    message = Array.isArray(raw) ? raw.map(translateError).join('\n') : translateError(raw);
  } else {
    message = translateError(error?.message ?? error);
  }

  Swal.fire(title, message, 'error');
};
